import { Injectable, inject } from '@angular/core';

import { EnvironmentConfig } from '../../../client-config/index';
import { CmsService } from '../../../core/services/cms/cms.service';
import { ISystemConfig } from '../../../core/services/cms/models/system-config';
import { StorageService } from '../../../core/services/storage/storage.service';
import { UserService } from '../../../core/services/user/user.service';

@Injectable({ providedIn: 'root' })
export class MyBetsCollapseService {
    private readonly environment = inject(EnvironmentConfig).configuration;
    brand: string = this.environment.BRAND || '';
    betCollapse: string[] = [];
    myBetsCollapse = 60; //default to 60 min if cms is not configured
    keyCollapse: string;

    constructor(
        private storage: StorageService,
        private user: UserService,
        private cmsService: CmsService,
    ) {
        this.setAllStoredBetDataFromStorage();
    }

    setAllStoredBetDataFromStorage(): void {
        this.keyCollapse = `${this.user.username}`;
        this.betCollapse = !this.isStorageEmpty() ? this.storage.get(`bet-collapse`)[this.keyCollapse] : [];
    }

    setBetCollapseFlagToStorage(betId: string | number): void {
        this.betCollapse = this.betCollapse || [];
        this.removeStorageAsPerConfig(true);
        this.betCollapse.push(String(betId));
        this.setBetCollapseObj();
    }

    getBetCollapseFlagToStorage(betId: string | number): string | undefined {
        this.keyCollapse = `${this.user.username}`;
        const storageCollapsedData = this.storage.get(`bet-collapse`);
        const betData = (!this.isStorageEmpty() && storageCollapsedData[this.keyCollapse]) || [];
        let collapsedBet: string | undefined;
        const betIdStr = String(betId);
        betData.filter((eachBet: string) => {
            if (eachBet.includes(betIdStr)) {
                collapsedBet = eachBet;
            }
        });
        return collapsedBet;
    }

    removeBetCollapseFlag(betId: string | number): void {
        const storageCollapsedData = this.storage.get(`bet-collapse`);
        this.keyCollapse = `${this.user.username}`;
        const betCollapsedData = !this.isStorageEmpty() && storageCollapsedData[this.keyCollapse];
        this.betCollapse = this.betCollapse || [];
        const betIdStr = String(betId);
        const ind = this.betCollapse.findIndex((bet) => bet === betIdStr);
        this.betCollapse.splice(ind, 1);
        betCollapsedData.filter((betData: string, index: number) => {
            if (betData.includes(betIdStr)) {
                betCollapsedData.splice(index, 1);
                const newCollapseArr: Record<string, string[]> = {};
                newCollapseArr[this.keyCollapse] = betCollapsedData;
                this.storage.set(`bet-collapse`, newCollapseArr);
            }
        });
    }

    removeAllBetFromStorage(): void {
        const uName = this.user.username;
        const storageCollapseObj = this.storage.get('bet-collapse');
        let storageUName = '';
        if (!this.isStorageEmpty()) {
            storageUName = Object.keys(storageCollapseObj)[0];
        }
        const isUserExist = storageUName.includes(uName);
        if (!isUserExist) {
            this.storage.set(`bet-collapse`, {});
        } else {
            this.setAllStoredBetDataFromStorage();
        }
    }

    removeStorageAsPerConfig(isNewValAdded?: boolean): void {
        const collapsedBet = this.storage.get('bet-collapse');
        this.keyCollapse = `${this.user.username}`;
        const storageLimit = this.getStorageLimitCms();
        const betStorageLength = !this.isStorageEmpty() && collapsedBet[this.keyCollapse].length;
        let removable: number | undefined;
        this.betCollapse = this.betCollapse || [];
        if (storageLimit <= betStorageLength) {
            removable = betStorageLength - storageLimit;
        }
        if (typeof removable === 'number' && removable > 0) {
            for (let i = 0; i < removable; i++) {
                this.betCollapse.shift();
            }
        }
        if (isNewValAdded && removable === 0) {
            this.betCollapse.shift();
        }
        this.betCollapse.length && this.setBetCollapseObj();
    }

    isStorageEmpty(): boolean {
        const storageCollapsedData = this.storage.get(`bet-collapse`);
        return storageCollapsedData == null || Object.keys(storageCollapsedData).length === 0;
    }

    setBetCollapseObj(): void {
        this.keyCollapse = `${this.user.username}`;
        const newCollapseArr: Record<string, string[]> = {};
        newCollapseArr[this.keyCollapse] = this.betCollapse;
        this.storage.set(`bet-collapse`, newCollapseArr);
    }

    getStorageLimitCms(): number {
        this.cmsService.getSystemConfig().subscribe((config: ISystemConfig) => {
            if (config && config.MyBetsCollapse) {
                this.myBetsCollapse = config.MyBetsCollapse.storageLimit;
            }
        });
        return this.myBetsCollapse;
    }
}
